module.exports = __webpack_public_path__ + "static/media/finalComic.1b562481.png";